import React, { Component } from "react";
import {
  Container,
  Avatar,
  Typography,
  TextField,
  Grid,
  Button
} from "@material-ui/core";
//npm install @material-ui/icons - iconos de react-material-ui-design
import LockOutLineIcon from "@material-ui/icons/LockOutlined";
//npm install recompose
import { compose } from "recompose";
//accedemos a el consumer del objeto firebase en este componente
import { consumerFirebase } from "../../server";
//accedemos a la variable startSession del archivo session/actions/sessionAction - para cambiar el comportamiento del boton de registo
import { createUser } from "../../session/actions/sessionAction";
//invocamos al openMessageAction para mostrarlo en el callback.status al realizar la accion de login
import { openMessageError } from "../../session/actions/openMessageAction";
//para poder extraer el valor del dispatch necesitamos importar el StateContext del archivo session/store.js
import { StateContext } from "../../session/store";

const style = {
  icon: {
    display: "flex",
    marginTop: 20,
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center"
  },
  paper: {
    marginTop: 8,
    display: "flex",
    frexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: 8,
    backgroundColor: "#e53935"
  },
  form: {
    width: "100%",
    marginTop: 10
  },
  submit: {
    marginTop: 15,
    marginBotton: 20
  }
};

//limpiar los registros de los campos del formulario cuando embiamos datos a través de éste a la bbdd de firebase
/*const initialUser = {
    name: '',
    surname: '',
    email: '',
    password: ''
}*/
//Eliminamos la limpieza de campos del usuario, y cambiamos la funcionalidad a enviarr al usuario a la página home una ver realizado la creación del usuario en la bbdd

class RegisterUser extends Component {
  //extraemos los valores del context provider incluidos en la variable SessionContext para poder  usar sus variables globales en el buttonRegister, y en particualr poder usar el dispatch
  static contextType = StateContext;

  //definimos el estado del componente
  state = {
    //incluir el objeto firebase al state del componente
    firebase: null,
    usuario: {
      name: "",
      surname: "",
      email: "",
      password: ""
    }
  };

  //comprobar que el objeto firebase se ha modificado para camviar el objeto del estado del componente
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.firebase === prevState.firebase) {
      return null;
    }
    return {
      firebase: nextProps.firebase
    };
  }

  //guarda el texto proveniente del value
  onChangeInputs = e => {
    let usuario = Object.assign({}, this.state.usuario);
    usuario[e.target.name] = e.target.value;
    this.setState({
      usuario: usuario
    });
  };
  //submit de botón registro
  /*buttonRegister = e =>{
        e.preventDefault();
        //console.log('imprimir objeto usuario del state', this.state.usuario);
        
        //estraemos los valores del state
        const { user, firebase } = this.state;

        //escribimos el método de firebase para crear usuarios
        firebase.auth
        .createUserWithEmailAndPassword(user.email, user.password)
        .then(auth => {
            //definimos como se va a registrar el usuario en la BBDD
            const userDB = {
                userid : auth.user.uid,
                email : user.email,
                name : user.name,
                surname : user.surname
            }

            //llamamos al objeto de firebase para guardar usuarios
            firebase.db
            .collection("Users")
            .add(userDB)
            .then(userAfter => {
                console.log('Esta inserción fue un éxito', userAfter);
                //cambiamos el estado del componente y lo iniciamos con la variable initialUser
                //this.setState({
                    user : initialUser
                })
                //enviamos a el usuario registrado a la página home
                this.props.history.push("/");
                
            })
            .catch(error => {
                console.log('Hubo un error al guardar al usuario en la base de datos', error);
            })
        })
        .catch(error => {
            console.log('Hubo un error al crear el usuario en la base de datos', error);
        })
    }*/

  //implementacion a traves de actions y reducers
  buttonRegister = async e => {
    e.preventDefault();
    //extraemos los valores de sesion y dispatch del contexType que viene del StateContext del context provider global - del archivo sesion/reducers/index.js
    const [{ sesion }, dispatch] = this.context;

    //extraemos el objeto firebase y user del estado del componente
    const { firebase, usuario } = this.state;
    let callback = await createUser(dispatch, firebase, usuario);
    //console.log(callback);
    if (callback.status) {
      this.props.history.push("/");
    } else {
      openMessageError(dispatch, {
        open: true,
        message: callback.message.message
      });
    }
  };

  render() {
    return (
      <Container maxWidth="md">
        <div style={style.icon}>
          <Avatar style={style.avatar}>
            <LockOutLineIcon />
          </Avatar>
          <Typography componet="h1" variant="h5">
            Registro
          </Typography>
        </div>

        <div style={style.paper}>
          <form style={style.form}>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <TextField
                  name="name"
                  onChange={this.onChangeInputs}
                  value={this.state.usuario.name}
                  fullWidth
                  label="name"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  name="surname"
                  onChange={this.onChangeInputs}
                  value={this.state.usuario.surname}
                  fullWidth
                  label="surname"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  name="email"
                  onChange={this.onChangeInputs}
                  value={this.state.usuario.email}
                  fullWidth
                  label="email"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  type="password"
                  name="password"
                  onChange={this.onChangeInputs}
                  value={this.state.usuario.password}
                  fullWidth
                  label="password"
                />
              </Grid>
            </Grid>
            <Grid container justify="center">
              <Grid item md={6} xs={12}>
                <Button
                  type="submit"
                  onClick={this.buttonRegister}
                  variant="contained"
                  fullWidth
                  size="large"
                  color="primary"
                  style={style.submit}
                >
                  Registro
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    );
  }
}

export default compose(consumerFirebase)(RegisterUser);
